<template>
  <div class="cmp-wrapper">
    <basic-container>
      <fixed-table></fixed-table>
    </basic-container>
  </div>
</template>


<script>
import FixedTable from "./../../../blocks/mc-fixed-table/index.js";

export default {
  name: "",
  props: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
  components: {
    FixedTable
  }
};
</script>


<style lang="scss" scoped>
.cmp-wrapper {
}
</style>
